import React, { useRef, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import UserList from './UserList';
import UserDisplay from './UserDisplay';
import UserEdit from './UserEdit';
import AddNewUser from './AddNewUser';
import UpdatePassword from './UpdatePassword';
import {
  loadUsers,
  loadUserStatuses,
  loadCheckinModes,
} from '../../redux/actions/userActions';
import { loadUnits } from '../../redux/actions/unitActions';
import UsersImport from './utilities/UsersImport';
import UsersExport from './utilities/UsersExport';
import { getSiteInfo } from '../../redux/actions/systemActions';
import { getAlertGroupPermissions } from '../../redux/actions/userStaffPreferencesActions';
// import { getDeviceAssociations } from "../../redux/actions/alarmDeviceActions";

/**
 * The function to display the appropriate components for users.
 * @description - React Router takes the url paths and displays the appropriate components. If the route is /users/ it will display the list of users. If the Route is /users/ followed by a number, it will display the full view of that user. If it's /users/edit/ followed by a number, it will display the edit view for that user
 */

function Users(props) {
  const location = useLocation();
  const { state, pathname } = location;
  const previousLocation = useRef(location);

  /**
   * Function to load units and users from the API to populate the page
   * @fires dispatch#loadUnits - Redux action to pull units information from the API
   * @fires dispatch#loadUsers - Redux action to pull users information from the API
   * @description - This function uses React Hooks to add lifecycle methods. By adding the [] parameter at the end of the hook, it will only fire once. Eslint wants the second paramter to have something in it so it's necessary to add the commented "eslint-disable-line" to prevent it from automatically adding the extra information which will cause the hook to fire every time the component updates.
   */
  useEffect(() => {
    props.dispatch(loadUserStatuses());
    props.dispatch(loadUnits());
    props.dispatch(loadUsers());
    props.dispatch(loadCheckinModes());
    props.dispatch(getSiteInfo());
    props.dispatch(getAlertGroupPermissions());
  }, []); // eslint-disable-line

  if (state && state.modal) {
    if (
      pathname === '/users/addUser/' ||
      pathname === '/users/:id/updatePassword/' ||
      pathname === '/users/:id/edit/' ||
      pathname === '/users/export/' ||
      pathname === '/users/import/'
    ) {
      previousLocation.current = { pathname: '/users/' };
    }
  }

  useEffect(() => {
    if (location) {
      if (state && state.modal) {
        previousLocation.current = { pathname: '/users/' };
      } else {
        previousLocation.current = location;
      }
    }
  }, [location, state]);

  let isModal = false;
  if (state && state.modal) {
    isModal = true;
  }

  return (
    <React.Fragment>
      {/* The Routes is used to set the background to display underneath the overlay component. It checks to see if the url being loaded involves a modal and uses the route found in the previousLocation ref to set the contents of the Routes */}
      <Routes location={isModal ? previousLocation.current : location}>
        <Route
          index
          element={<UserList />}
          data-test="users-route"
        />
        <Route
          path=":id/view"
          element={<UserDisplay />}
          data-test="view-route"
        />
        <Route
          path=":id/edit"
          element={<UserEdit />}
          data-test="edit-route"
        />
        <Route
          path="addUser"
          element={<AddNewUser />}
          data-test="add-route"
        />
        <Route
          path=":id/updatePassword"
          element={<UpdatePassword />}
          data-test="update-password-route"
        />
        <Route
          path="import"
          element={<UsersImport />}
          data-test="users-import-route"
        />
        <Route
          path="export"
          element={<UsersExport />}
          data-test="users-export-route"
        />
      </Routes>
    </React.Fragment>
  );
}
export default connect()(Users);
